import fr from 'facet-rest';
import React from 'react';
import RoadmapDeliverableInvestingDetails from './RoadmapDeliverableInvestingDetails/RoadmapDeliverableInvestingDetails';

const RoadmapDeliverableInvestingDetailsPicker = ({ resource }) => {
  return resource.withRelationship(fr.relationships.investingDetails.name, (rel) => <RoadmapDeliverableInvestingDetails relationship={rel} />, () => null);
};

export default RoadmapDeliverableInvestingDetailsPicker;
